import { render, staticRenderFns } from "./ResourceTree.vue?vue&type=template&id=646ae26e"
import script from "./ResourceTree.vue?vue&type=script&lang=js"
export * from "./ResourceTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports